import { render, staticRenderFns } from "./applyAmtOrderStatistics.vue?vue&type=template&id=0b4d4ba8&scoped=true&"
import script from "./applyAmtOrderStatistics.vue?vue&type=script&lang=js&"
export * from "./applyAmtOrderStatistics.vue?vue&type=script&lang=js&"
import style0 from "./applyAmtOrderStatistics.vue?vue&type=style&index=0&id=0b4d4ba8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4d4ba8",
  null
  
)

export default component.exports